var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationBlankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.38,
    height: 191.998,
    viewBox: "0 0 282.38 191.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Intergration_Blank",
    transform: "translate(2328.255 24337.002)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 70.293,
    cy: 70.293,
    r: 70.293,
    transform: "translate(-2296.167 -24329.58)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 13.31,
    cy: 13.31,
    r: 13.31,
    transform: "translate(-2157.66 -24217.693)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M688.337,608.014a5.877,5.877,0,0,1-4.6,3.157c-.5.052-.35.813.143.761a6.586,6.586,0,0,0,5.093-3.481.4.4,0,0,0-.1-.538.389.389,0,0,0-.538.1Z",
    transform: "translate(-2788.876 -24756.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M434.7,453.88a67.828,67.828,0,0,1-67.147-59.245l.825-.1a66.9,66.9,0,0,0,132.739-16.769l.825-.1A67.767,67.767,0,0,1,434.7,453.88Z",
    transform: "translate(-2604.384 -24622.492)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M511.8,561.842H498.574a1.872,1.872,0,0,1-1.47-.708,1.833,1.833,0,0,1-.359-1.558,35.985,35.985,0,0,0-.216-16.8,1.862,1.862,0,0,1,.812-2.027c4.576-2.835,9.559-2.746,15.235.271a1.893,1.893,0,0,1,.985,1.362,58.88,58.88,0,0,1,.1,17.854A1.868,1.868,0,0,1,511.8,561.842Z",
    transform: "translate(-2679.68 -24716.541)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M366.785,389.729H353.556a1.872,1.872,0,0,1-1.47-.708,1.833,1.833,0,0,1-.359-1.558,35.974,35.974,0,0,0-.231-16.86,1.875,1.875,0,0,1,.728-1.971c6.8-4.892,12.159-4.75,15.922.423a1.879,1.879,0,0,1,.329.794,58.87,58.87,0,0,1,.165,18.27,1.868,1.868,0,0,1-1.855,1.61Z",
    transform: "translate(-2594.972 -24615.139)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M510.746,561.848H506.2a.949.949,0,0,1,0-1.9h4.551a.949.949,0,0,1,0,1.9Z",
    transform: "translate(-2684.804 -24728.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M516.31,570.861H506.2a.949.949,0,0,1,0-1.9H516.31a.949.949,0,0,1,0,1.9Z",
    transform: "translate(-2684.804 -24734.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M370.746,389.848H366.2a.949.949,0,1,1,0-1.9h4.551a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2603.035 -24628.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M370.746,397.848H366.2a.949.949,0,1,1,0-1.9h4.551a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2603.035 -24633.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M370.746,405.848H366.2a.949.949,0,1,1,0-1.9h4.551a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2603.035 -24637.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M750.989,413.358H708.7a4.279,4.279,0,0,1-4.274-4.274V383.04a4.279,4.279,0,0,1,4.274-4.275h42.286a4.279,4.279,0,0,1,4.274,4.274v26.044A4.279,4.279,0,0,1,750.989,413.358Z",
    transform: "translate(-2801.139 -24623.139)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M738.743,414.714H716.23a4.008,4.008,0,0,1-4-4V390.833a4.008,4.008,0,0,1,4-4h36.341a4.008,4.008,0,0,1,4,4v6.049A17.852,17.852,0,0,1,738.743,414.714Z",
    transform: "translate(-2805.694 -24627.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M758.326,410.334H729.236a.949.949,0,0,1,0-1.9h29.091a.949.949,0,0,1,0,1.9Z",
    transform: "translate(-2815.074 -24640.471)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M733.786,419.347h-4.55a.949.949,0,1,1,0-1.9h4.551a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2815.074 -24645.734)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M741.846,428.361h-12.61a.949.949,0,0,1,0-1.9h12.61a.949.949,0,0,1,0,1.9Z",
    transform: "translate(-2815.074 -24650.998)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 8.945,
    cy: 8.945,
    r: 8.945,
    transform: "translate(-2107.131 -24253.838)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M457.431,187.487a23.328,23.328,0,1,1,45.777,9.018l-.816-.161a22.5,22.5,0,1,0-44.144-8.7Z",
    transform: "translate(-2656.877 -24500.428)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M456.151,217.492l-13.217.548a1.872,1.872,0,0,1-1.5-.647,1.834,1.834,0,0,1-.423-1.542,35.994,35.994,0,0,0-.863-16.618,1.86,1.86,0,0,1,.918-2.174c5.414-2.813,10.486-2.955,15.076-.424a1.883,1.883,0,0,1,.945,1.273,58.877,58.877,0,0,1,.849,17.9A1.868,1.868,0,0,1,456.151,217.492Z",
    transform: "translate(-2646.739 -24515.715)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M461.805,225.842l-10.106.418a.949.949,0,1,1-.079-1.9l10.106-.419a.949.949,0,0,1,.078,1.9Z",
    transform: "translate(-2652.952 -24532.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M461.475,217.849l-10.106.419a.949.949,0,1,1-.079-1.9l10.106-.419a.949.949,0,0,1,.079,1.9Z",
    transform: "translate(-2652.759 -24528.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M621.3,190.662H579.019a4.279,4.279,0,0,1-4.274-4.274V160.344a4.279,4.279,0,0,1,4.274-4.275H621.3a4.279,4.279,0,0,1,4.274,4.275v26.044A4.279,4.279,0,0,1,621.3,190.662Z",
    transform: "translate(-2725.395 -24493.07)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M609.058,192.019H586.545a4.008,4.008,0,0,1-4-4V168.138a4.008,4.008,0,0,1,4-4h36.341a4.008,4.008,0,0,1,4,4v6.049A17.852,17.852,0,0,1,609.058,192.019Z",
    transform: "translate(-2729.949 -24497.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M628.642,187.638H599.551a.949.949,0,0,1,0-1.9h29.091a.949.949,0,0,1,0,1.9Z",
    transform: "translate(-2739.33 -24510.402)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M604.1,196.652h-4.551a.949.949,0,1,1,0-1.9H604.1a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2739.33 -24515.666)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M612.161,205.665h-12.61a.949.949,0,0,1,0-1.9h12.61a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2739.33 -24520.93)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    cx: 8.945,
    cy: 8.945,
    r: 8.945,
    transform: "translate(-2165.542 -24299.748) rotate(-58.134)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M278.5,332.133a39.111,39.111,0,0,1,73.162-27.676l-.778.294a38.279,38.279,0,0,0-71.606,27.087Z",
    transform: "translate(-2550.888 -24564.971)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M342.815,280.9H329.586a1.872,1.872,0,0,1-1.47-.708,1.834,1.834,0,0,1-.359-1.558,35.984,35.984,0,0,0-.207-16.766,1.856,1.856,0,0,1,.856-2.054c4.792-2.789,9.909-2.7,15.209.254a1.877,1.877,0,0,1,.954,1.345,58.881,58.881,0,0,1,.1,17.876,1.868,1.868,0,0,1-1.855,1.61Z",
    transform: "translate(-2580.985 -24552.479)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M341.746,279.848H337.2a.949.949,0,1,1,0-1.9h4.551a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2586.097 -24564.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M347.31,288.861H337.2a.949.949,0,1,1,0-1.9H347.31a.949.949,0,0,1,0,1.9Z",
    transform: "translate(-2586.097 -24569.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M194.3,356.662H152.019a4.279,4.279,0,0,1-4.274-4.274V326.344a4.279,4.279,0,0,1,4.274-4.274H194.3a4.279,4.279,0,0,1,4.274,4.274v26.044a4.279,4.279,0,0,1-4.274,4.275Z",
    transform: "translate(-2476 -24590.025)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M182.058,358.019H159.545a4.008,4.008,0,0,1-4-4V334.138a4.008,4.008,0,0,1,4-4h36.341a4.008,4.008,0,0,1,4,4v6.049A17.852,17.852,0,0,1,182.058,358.019Z",
    transform: "translate(-2480.554 -24594.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M201.642,353.638H172.551a.949.949,0,1,1,0-1.9h29.091a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2489.934 -24607.355)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M177.1,362.652h-4.551a.949.949,0,1,1,0-1.9H177.1a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2489.934 -24612.619)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M185.161,371.665h-12.61a.949.949,0,1,1,0-1.9h12.61a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2489.934 -24617.885)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 8.945,
    cy: 8.945,
    r: 8.945,
    transform: "translate(-2284.915 -24231.535) rotate(-58.134)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M451.827,340H438.6a1.872,1.872,0,0,1-1.47-.708,1.833,1.833,0,0,1-.359-1.558,35.986,35.986,0,0,0-.2-16.737,1.867,1.867,0,0,1,.883-2.071c6.426-3.678,11.514-3.577,15.556.311a1.847,1.847,0,0,1,.532,1.03,58.877,58.877,0,0,1,.141,18.123A1.868,1.868,0,0,1,451.827,340Z",
    transform: "translate(-2644.66 -24586.621)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M452.746,340.848H448.2a.949.949,0,0,1,0-1.9h4.55a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2650.928 -24599.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M458.31,349.861H448.2a.949.949,0,0,1,0-1.9H458.31a.949.949,0,1,1,0,1.9Z",
    transform: "translate(-2650.928 -24605.15)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationBlankIcon);
export default __webpack_public_path__ + "static/media/integration-blank-icon.b65adf63a2848f4f550012c74f08ef8d.svg";
export { ForwardRef as ReactComponent };